export default __webpack_public_path__ + "static/media/age-img.419a94be.png";